<style lang="scss">
.waiting-room-page {
  &__title {
    @include mobile-portrait() {
      margin-top: 25px !important;
    }
  }

  .profile-img {
    border-radius: 100%;
    width: 120px;
    height: 120px;
    object-fit: cover;
  }

  .join-call-bar {
    @include positioningOffset(fixed, unset, unset, 30px, 0);
    background-color: white;
  }
}
</style>

<!-- eslint-disable -->
<template>
  <div>
    <div class="waiting-room-page row mb-4 mx-auto">
      <div class="col-6">
        <b-card>
          <section class="waiting-room-page__title mb-1">
            <h2 class="font-weight-bolder mb-1">Call Details</h2>
          </section>

          <section v-if="!loading && call && visitor">

            <div class="d-flex justify-content-between flex-column">
              <div class="d-flex justify-content-start">
              <span class="b-avatar badge-light-danger rounded" style="width: 104px; height: 104px;">
                  <span class="b-avatar-img">
                    <img :src="visitor.profile_picture_url || placeholder" alt="avatar">
                  </span><!---->
                </span>
                <div class="d-flex flex-column ml-1">
                  <div class="mb-1">
                    <h4 class="mb-0"> {{ call.visitor.firstname }} {{ call.visitor.lastname }} </h4>
                    <span class="card-text">
                      Date: {{ call.booked_slot.start_date_time | formatDate }}
                      <br>
                      Time: {{ call.booked_slot.slot_begin }} - {{ call.booked_slot.slot_end }}
                    </span>
                  </div>
                  <div class="d-flex flex-wrap">

                    <b-btn @click="backToDashboard()" size="sm" variant="warning">
                      <span class="fas fa-arrow-circle-left"></span> Back
                    </b-btn>

                    <b-btn @click="startCall" size="sm" class="ml-1" :class="{'disabled': !isCallReady(call)}" variant="primary">
                      <span class="fas fa-camera"></span>
                      Enter Call
                    </b-btn>

                  </div>
                </div>
              </div>
            </div>

            <section class="mt-2 mb-1">
              <additional-participant-list></additional-participant-list>
            </section>

            <section>
              <h4 class="font-weight-bolder">Call Reminder</h4>
              <p>Please remember that only approved participants are permitted to be on this call,
                if an unapproved participant is detected your call may be terminated and you may lose the ability to have
                calls in the future.
              </p>

              <p>Please note: This call will be recorded and may be monitored by a member of staff, during monitoring
                staff
                will be able to both hear and see you and your participants.
              </p>
            </section>
          </section>

          <section v-else>
            <b-spinner variant="primary" label="Loading"></b-spinner>
          </section>
        </b-card>
      </div>
      <div class="col-6">
        <b-card v-if="!loading && call && visitor">
          <section>
            <h4 class="font-weight-bolder">Call Waiting</h4>
            <p>You are now in the waiting room. When {{ visitor.firstname }} has passed verification you will be able to
              join.</p>
            <p>Please take some time to read any messages or announcements below.</p>
          </section>

          <section class="mt-2" cy="announcement-waiting" v-if="announcement">
            <announcement key="main-announcement" :announcement="announcement"></announcement>
          </section>

          <section class="d-flex justify-content-end join-call-bar full-width p-1 box-shadow-1">

            <b-btn @click="backToDashboard()" variant="warning">
              <span class="fas fa-arrow-circle-left"></span> Back to Dashboard
            </b-btn>

            <b-btn :disabled="reminderSent" @click="sendReminderToVisitor()" variant="warning"  class="ml-1">
              <span class="fas fa-bell"></span> Send Reminder
            </b-btn>
            <b-btn @click="startCall" class="ml-1"
                   :class="{'disabled': !isCallReady(call)}" variant="primary">
              <span class="fas fa-camera"></span>
              Enter Call
            </b-btn>
          </section>
        </b-card>
      </div>
    </div>

    <b-modal id="modal-announcement" title="Pre Call Announcement" hide-footer>
      <announcement v-if="announcementPreCall"
                    key="pre-announcement" :announcement="announcementPreCall"></announcement>
    </b-modal>
  </div>
</template>
<!-- eslint-enable -->

<script>
import { mapState } from 'vuex';
import CallEventsService from '@/services/CallEventsService';
import VisitorUsersService from '@/services/VisitorUsersService';
import Announcement from '@/components/announcement/Annoucement.vue';
import VisitsService from '@/services/VisitsService';
import AdditionalParticipantList from '@/views/waitingRoom/additionalParticipants/AdditionalParticipantList.vue';

export default {
  name: 'WaitingRoom',
  components: {
    Announcement,
    AdditionalParticipantList,
  },
  data() {
    return {
      id: null,
      loading: false,
      // eslint-disable-next-line global-require
      placeholder: require('../../assets/images/id/placeholder.png'),
      announcement: null,
      announcementPreCall: null,
      intervalPoll: '',
      visitor: null,
      reminderSent: false,
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      call: state => state.myCalls.call,
    }),
  },
  mounted() {
    this.id = this.$route.params.id;
    this.loading = true; // loading here as call is polled so not set in fn
    this.getCall();
    this.pollItems();
  },
  beforeDestroy() {
    clearInterval(this.intervalPoll);
    // this.updateWaitingRoomStatus(false);
  },
  methods: {
    getCall() {
      this.$store.dispatch('myCalls/refreshCall', this.id).then(() => {
        if (this.call.status !== 'Approved') { // redirect
          this.$router.push({ name: 'call-details', params: { id: this.id } });
        }

        if (this.loading) { // only do on first load
          this.getAnnouncementsForWaitingRoom();
          this.getPrecallAnnouncements();
          this.getVisitor();
        }

        this.loading = false;
      }).catch(() => {
        this.$toast.error('Could not get call, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'], timeout: 5000,
        });
      })
    },
    getAnnouncementsForWaitingRoom() {
      CallEventsService.getAnnouncementWaitingRoom().then(res => {
        if (res.data) {
          this.announcement = res.data;
        }
      });
    },
    getPrecallAnnouncements() {
      CallEventsService.checkPreCallAnnouncements().then(res => {
        if (res.data) {
          this.announcementPreCall = res.data;
          this.$bvModal.show('modal-announcement');
        }
      });
    },
    closeModals() {
      this.$bvModal.hide('modal-announcement');
    },
    pollItems() {
      this.intervalPoll = setInterval(() => {
        this.getCall();
      }, 10000);
    },
    // updateWaitingRoomStatus(inRoom) {
    //   VisitsService.updateWaitingRoomStatus(this.id, {
    //     visitor_in_waiting_room: inRoom,
    //   }).then(res => res);
    // },
    isCallReady(call) {
      if (call) {
        const callSecurityJoined = call.call_state.call_security_joined || false;
        const passedPreCall = call.call_state.visitor_passed_pre_call_security || false;
        const waitingRoomOrInCall = call.call_state.visitor_in_waiting_room || call.call_state.visitor_in_call;
        return callSecurityJoined && passedPreCall && waitingRoomOrInCall;
      }
      return false;
    },
    getVisitor() {
      VisitorUsersService.getUser(this.call.visitor.user_id).then(res => {
        this.visitor = res.data;
      }).catch(() => {
        this.$toast.error('Could not get call information, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'], timeout: 5000,
        });
      })
    },
    sendReminderToVisitor() {
      this.reminderSent = true;

      VisitsService.sendReminderToVisitor(this.id, {}).then(() => {
        this.$toast.success(`A reminder has been sent to ${this.call.visitor.firstname}`, {
          toastClassName: ['toast-std', 'success-toast'], timeout: 5000,
        });
      }).catch(() => {
        this.$toast.error(`Error sending a reminder to ${this.call.visitor.firstname}, please try again`, {
          toastClassName: ['toast-std', 'warning-toast'], timeout: 5000,
        });
        // Allow them to try again
        this.reminderSent = false;
      });
    },
    backToDashboard() {
      this.$router.push({ name: 'dashboard' });
    },
    startCall() {
      this.$router.push({
        name: 'live-call',
        params: {
          // eslint-disable-next-line no-underscore-dangle
          visitId: this.id, prisonerNumber: this.call.prisoner.prisoner_number,
        },
      });
    },
  },
}
</script>
